// Custom search for subBranches
const filterBranches = document.querySelector('#filterBranches');
const searchitems = document.querySelectorAll('[data-searchitem]');
const branchboxes = document.querySelectorAll('[data-branchbox]');
const noResults = document.querySelector('[data-no-results]');
if (filterBranches && searchitems && branchboxes && noResults) {
    filterBranches.addEventListener('keyup', () => {
        let inputText = filterBranches.value.toLowerCase();
        inputText = inputText.replace(/ /g, '');
        inputText = inputText.replace('-', '');
        let subbranchesMatched = 0;

        if (inputText.length > 1) {
            searchitems.forEach(searchitem => {
                searchitem.classList.remove('hide');
            });
            branchboxes.forEach(branchbox => {
                branchbox.classList.remove('hide');
                const boxSearchItems = branchbox.querySelectorAll('[data-searchitem]');
                boxSearchItems.forEach(boxSearchItem => {
                    const boxSearchItemText = boxSearchItem.dataset.searchitem;
                    if (boxSearchItemText.indexOf(inputText) !== -1) {
                        subbranchesMatched++;
                        boxSearchItem.classList.remove('hide');
                    } else {
                        if (!boxSearchItem.hasAttribute('data-mainbranch')) {
                            boxSearchItem.classList.add('hide');
                        }
                    }
                });
                if (subbranchesMatched) {
                    branchbox.classList.remove('hide');
                } else {
                    branchbox.classList.add('hide');
                }
                subbranchesMatched = 0;
            });
            const branchboxesArray = Array.from(branchboxes);
            const visibleBranchboxes = branchboxesArray.filter(branchbox => !branchbox.classList.contains('hide'));
            if (visibleBranchboxes.length > 0) {
                noResults.classList.add('hide');
            } else {
                noResults.classList.remove('hide');
            }
        } else {
            searchitems.forEach(searchitem => {
                searchitem.classList.remove('hide');
            });
            branchboxes.forEach(branchbox => {
                branchbox.classList.remove('hide');
            });
            noResults.classList.add('hide');
        }
    });
}
